import { z } from "zod";

export const CustomerProfileSchema = z.object({
  id: z.string(),
  user_id: z.string(),

  job_title: z.string().nullish(),
  ad_use_case: z.string().nullish(),
  ad_creation_frequency: z.string().nullish(),
  advertising_platforms: z.any().nullish(),
  content_types_needed: z.any().nullish(),

  retention_credit_availed: z.boolean().nullish(),
  retention_coupon_availed: z.boolean().nullish(),

  onboarded_at: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const CompanyProfileSchema = z.object({
  id: z.string(),
  organization_id: z.string(),

  company_name: z.string().nullish(),
  company_website: z.string().nullish(),
  company_industry: z.string().nullish(),

  brand_logo: z.string().nullish(),
  brand_metadata: z.any().nullish(),
  brand_report: z.any().nullish(),
  brand_summary: z.any().nullish(),
  /** `any`: backend often returns richer or legacy shapes; strict Brand DNA parsing must not block the app. */
  brand_guidelines: z.any().nullish(),

  brand_research_metadata: z.any().nullish(),
  brand_research_session_id: z.string().nullish(),
  brand_research_started_at: z.string().nullish(),
  brand_research_completed_at: z.string().nullish(),
  /** Allow new status values from the API without a client deploy. */
  brand_research_status: z.string().nullish(),
  brand_research_version: z.coerce.number().nullish(),

  /** Optional allowlist of feature modules the org has subscribed to (e.g. `ai_paid_media`). */
  modules: z.array(z.string()).optional(),

  created_at: z.string(),
  updated_at: z.string(),
});

export type CustomerProfile = z.infer<typeof CustomerProfileSchema>;
export type CompanyProfile = z.infer<typeof CompanyProfileSchema>;
/** Subscription module id matched against `company.modules` (e.g. `ai_paid_media`). */
export type CompanyProfileModule = string;
